import { RECEIPT_STEPS } from "../receipt-steps.service";
import { BaseState } from "./base-state";
import { ExpenseSelectionState } from "./expense-selection-state";
import { StepStateInterface } from "./step-state.interface";

export class FoodDataState extends BaseState implements StepStateInterface {
  ClassConstructor = FoodDataState;
  property = 'foodData';
  slug = RECEIPT_STEPS.foodData;
  lastStep = true;
  async previous(context: any): Promise<StepStateInterface> {
    return new ExpenseSelectionState();
  }
}
